import { useState } from "react";
import { Button, Input, Form, Typography, notification } from 'antd';
import Localize from '../../utils/string';
import { change_password } from "../../store/emailAndPassword/emailAndPasswordAsyncActions";
import { useDispatch, useSelector } from "react-redux";

const NewPassword = () => {
    const dispatch = useDispatch();
    const [passwordError, setPasswordError] = useState("")
    const [loading, setLoading] = useState(false);
    const userSession = useSelector((state: any) => state.user.userSession)

    const onSubmit = async (values: any) => {
        setLoading(true);
        const { oldPassword, newPassword, renterPassword } = values;
        if (newPassword !== renterPassword) {
            setLoading(false);
            setPasswordError("Password and confirm password does not match!");
            return false;
        }
        if (newPassword === oldPassword) {
            setLoading(false);
            setPasswordError("New Password and old Password are same!");
            return false;
        }
        const params = { password: newPassword, oldPassword, confirmPassword: renterPassword, email: userSession?.email }
        try {
            await dispatch(change_password(params))
            notification.open({
                message: '',
                description:'Password changed successfully',
                placement:"bottomRight"
            });
            //     className: 'custom-class',
            //     style: {
            //       width: 400,
            //       marginTop:'40px'
            //     },
            //   });
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }
    return (
        <div className="user-profile" data-testid="sign-in">
            <Typography.Title className="setting-tab-heading" level={4} >{Localize.ChangePassword}</Typography.Title>
            {passwordError && <p className="error-message">{passwordError}</p>}
            <Form
                name=""
                layout="vertical" onFinish={onSubmit}>
                <Form.Item
                    label="Old Password"
                    name="oldPassword"
                    required
                    rules={[{ required: true }]}
                >
                    <Input.Password placeholder="old password..." />
                </Form.Item>
                <Form.Item
                    label="New Password"
                    name="newPassword"
                    required
                    rules={[{ required: true, min: 6 }, { min: 6 }]}
                >
                    <Input.Password placeholder="new password..." />
                </Form.Item>
                <Form.Item
                    label="Confirm Password"
                    name="renterPassword"
                    required
                    rules={[{ required: true }]}
                >
                    <Input.Password placeholder="re-enter password..." />
                </Form.Item>
                <Form.Item
                    className="form-btn"
                >
                    <Button loading={loading} type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}

export default NewPassword;